'use strict'

var schema = require('property-information/html')
var factory = require('./factory')

var html = factory(schema, 'div')
html.displayName = 'html'

module.exports = html



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/hastscript/html.js
// module id = 1351
// module chunks = 0